var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[{
    [_vm.$style.dropDownButton]: !_vm.useLinkStyleForButton && !_vm.useDarkLinkStyleForButton,
    [_vm.$style.dropDownButtonDarkLinkStyle]: _vm.useDarkLinkStyleForButton && !_vm.disabled,
    [_vm.$style.dropDownButtonDisabled]: _vm.disabled,
    [_vm.$style.dropDownButtonLinkStyle]: _vm.useLinkStyleForButton,
    [_vm.$style.dropDownButtonLinkStyleActive]: _vm.active,
  }, _vm.$style.dropDownButtonPosition],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.includeCaret)?_c('CaretIcon',{class:_vm.$style.caret}):_vm._e(),(_vm.removable)?_c('CloseIcon',{ref:"closeIcon",class:_vm.$style.closeIcon,on:{"click":_vm.handleCloseClick}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }